var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4948 0.634865C29.4683 0.41471 29.4331 0.212167 29.4067 0.0448484C29.3979 -0.0256014 29.2834 -0.00798921 29.2834 0.0624606C29.301 0.828602 29.5828 1.9558 29.1513 2.6603C28.4997 3.70824 27.1435 2.63388 26.5007 2.11431C25.2854 1.12801 24.0877 0.0184295 22.4146 0.0184295C20.6885 0.0184295 19.2795 0.899052 18.0291 1.99983C17.4214 2.53701 16.6905 3.083 16.2942 3.80511C16.0653 4.219 15.8891 4.70334 15.44 4.94111C15.2991 5.02037 15.1494 5.0732 14.9997 5.10843C14.85 5.0732 14.7003 5.02037 14.5594 4.94111C14.1191 4.70334 13.943 4.219 13.7052 3.80511C13.3001 3.083 12.578 2.53701 11.9704 1.99983C10.7111 0.899052 9.30208 0.0184295 7.58487 0.0184295C5.91169 0.0184295 4.72285 1.12801 3.49878 2.11431C2.85593 2.63388 1.49977 3.70824 0.848106 2.6603C0.416601 1.9558 0.6984 0.828602 0.716013 0.0624606C0.716013 -0.00798921 0.601532 -0.0256014 0.592726 0.0448484C0.566307 0.220973 0.539889 0.423516 0.504664 0.634865C-0.569696 5.22291 0.125995 10.1984 2.07217 14.4518C2.58293 15.5702 3.18176 16.6974 3.93909 17.6661C4.59956 18.5115 5.41854 19.1808 6.32558 19.7444C8.15727 20.8804 10.2355 21.5497 12.0496 22.7297C12.6484 23.1172 13.1592 23.6015 13.7052 24.0594C14.0751 24.3677 14.533 24.5878 15.0085 24.5702C15.4841 24.5878 15.9332 24.3677 16.3118 24.0594C16.8578 23.6015 17.3686 23.1172 17.9674 22.7297C19.7815 21.5585 21.8598 20.8892 23.6915 19.7444C24.5985 19.1808 25.4175 18.5115 26.0779 17.6661C26.8353 16.6974 27.4341 15.5702 27.9449 14.4518C29.8734 10.1896 30.5691 5.22291 29.4948 0.634865ZM18.17 16.4773C17.8529 15.9225 17.8617 15.2268 17.941 14.6103C18.0467 13.8002 18.3989 13.1485 19.077 12.6642C20.1425 11.898 21.5339 11.0702 22.8813 11.0262C24.1758 10.9822 25.5672 11.81 26.8441 11.352C27.2492 11.2023 27.6102 10.9558 27.8832 10.6299C27.575 11.3256 27.1347 11.9597 26.5975 12.5233C25.7962 13.3599 24.8715 14.1524 23.9204 14.8217C22.9077 15.535 21.7541 15.8256 20.5653 16.1162C19.7639 16.3011 18.9713 16.442 18.17 16.4773ZM11.8383 16.4773C11.0369 16.442 10.2444 16.3099 9.43418 16.1074C8.24534 15.8168 7.09172 15.5262 6.079 14.8129C5.12793 14.1436 4.21209 13.3511 3.40191 12.5145C2.86473 11.9597 2.42442 11.3256 2.1162 10.6211C2.3892 10.947 2.75025 11.2023 3.15534 11.3432C4.43224 11.8012 5.82362 10.9734 7.11814 11.0174C8.45669 11.0614 9.85688 11.898 10.9224 12.6554C11.5917 13.1397 11.944 13.7914 12.0584 14.6015C12.1465 15.2268 12.1553 15.9225 11.8383 16.4773Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "nav_gradient_paint",
    x1: 1.85023e-8,
    y1: 13.1046,
    x2: 30,
    y2: 13.1046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nav_gradient_active_paint",
    x1: 1.85023e-8,
    y1: 13.1046,
    x2: 30,
    y2: 13.1046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 2,
    stopColor: "#153059"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersona);
export default __webpack_public_path__ + "static/media/persona.bb979aa5039df0212fffff8403837300.svg";
export { ForwardRef as ReactComponent };